import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { generateChecksum } from '../middleware/generateChecksum';

export const bankApi = createApi({
  reducerPath: 'bankApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + '/v2/api/',
  }),
  endpoints: (builder) => ({
    getBankList: builder.mutation({
      query: (data) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          secret: data.scrt,
          jwt_token: data.jwt_token,
        },
        body: new URLSearchParams({
          mode: 'getBankList',
          checksum: data.checksum,
          lamf: '',
        }).toString(),
      }),
    }),

    getAggregatorBankList: builder.mutation({
      query: (data) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          secret: data.scrt,
          jwt_token: data.jwt_token,
        },
        body: new URLSearchParams({
          mode: 'account-aggregator-bank-list',
          checksum: data.checksum,
          device_id: data.device_id,
        }).toString(),
      }),
    }),
    
    getStashCash: builder.mutation({
      query: (data) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          secret: data.scrt,
          jwt_token: data.jwt_token
        },
        body: new URLSearchParams({
          mode: 'get_stashcash',
          checksum: generateChecksum({ mode: 'get_stashcash' }),
        }).toString(),
      }),
    }),

    getIFSCDetails: builder.query({
      query: (data) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          secret: data.scrt,
          jwt_token: data.jwt_token
        },
        body: new URLSearchParams({
          mode: 'get_ifsc_details',
          ifsc: data.ifsc,
          checksum: data.checksum,
        }).toString()
      }),
    }),

    updateBankDetails: builder.mutation({
      query: (data) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          secret: data.scrt,
          jwt_token: data.jwt_token
        },
        body: new URLSearchParams({
          ifsc_code: data.ifsc_code,
          account_no: data.account_no,
          meta_data: '',
          is_new: data.is_new,
          lamf: '',
          mode: 'bank_details',
          product_id: data.product_id || '',
          checksum: data.checksum,
          consents: typeof data.consents === 'string'
            ? data.consents
            : JSON.stringify(data.consents ?? []),
        }).toString(),
      }),
    }),

    updateOccupation: builder.mutation({
      query: (data) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          secret: data.scrt,
          jwt_token: data.jwt_token
        },
        body: new URLSearchParams({
          occupation: data.occupation,
          mode: 'submit_occupation',
          checksum: data.checksum,
          fip_ids: data.fip_ids,
          device_id: data.device_id
        }).toString(),
      }),
    }),

    uploadedDocumentList: builder.mutation({
      query: (data) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Request-Type': 'Android',
          device_id: data.device_id,
          device_version: data.device_version,
          version: data.version,
          auth_token: data.token,
        },
        body: JSON.stringify({
          mode: 'uploaded_document_list',
          product_id: data.product_id || '',
          checksum: data.checksum,
          lamf: '',
        }),
      }),
    }),
  }),
});

export const {
  useGetBankListMutation,
  useGetAggregatorBankListMutation,
  useGetStashCashMutation,
  useLazyGetIFSCDetailsQuery,
  useUpdateBankDetailsMutation,
  useUpdateOccupationMutation,
  useUploadedDocumentListMutation,
} = bankApi;
